import React from 'react'
import AllCampaigns from '/~/components/AllCampaigns'
import { Helmet } from '/~/components'
import { config } from '/~/utils/config'
import { Navigate, Route, Routes } from 'react-router'
import FinishedCampaigns from '/~/pages/FinishedCampaigns'

export const CampaignsPage = () => {
  return (
    <React.Fragment>
      <Helmet
        title='Folkeinvest: Aktuelle investeringsmuligheter'
        description='Folkeinvest er Norges ledende aktør på investering i unoterte aksjer hos startups og vekstbedrifter. Invester nå!'
        url={`${window.location.origin}/kampanjer`}
        imageUrl={`${config.publicFilesUrl}/meta/campaigns.png`}
        keywords='Invester i aksjer, invester i startups, investere, hente kapital, finansiering av startups'
      />
      <Routes>
        <Route path='avsluttede' Component={FinishedCampaigns} />
        <Route
          path=':campaignSlug*'
          element={<Navigate to={location.pathname.replace('kampanjer', 'kampanje')} replace />}
        />
        <Route path='' Component={AllCampaigns} />
      </Routes>
    </React.Fragment>
  )
}
